import * as Yup from 'yup';

const EMPTY_FIELD_ERROR_TEXT = 'required field';

const fieldsSchema = {
  isAddingContact: Yup.boolean(),
  firstName: Yup.string().trim().required(EMPTY_FIELD_ERROR_TEXT),
  lastName: Yup.string().trim().required(EMPTY_FIELD_ERROR_TEXT),
  title: Yup.string().trim().required(EMPTY_FIELD_ERROR_TEXT),
  customTitle: Yup.string().when('title', { is: 'Other', then: Yup.string().trim().required(EMPTY_FIELD_ERROR_TEXT) }),
  emailAeTool: Yup.string().trim().email('must be a valid email').required(EMPTY_FIELD_ERROR_TEXT),
  location: Yup.string().trim().required(EMPTY_FIELD_ERROR_TEXT),
  // ROCKY-27764: optional by request. The backend has always accepted it as null
  // (location_area: Optional[str], models.py:1077) — the requiredness was only ever here.
  locationArea: Yup.string().trim(),
  workstream: Yup.array(Yup.string()),
};

export const validationSchema = Yup.object().shape(fieldsSchema);
